import React, { useContext } from 'react';
import { IonButtons, IonButton, IonIcon, NavContext } from '@ionic/react';

export default (props: any) => {
  const { navigate } = useContext(NavContext);

  return (
    <IonButtons slot="start">
      <IonButton onClick={() => props.handler !== '' ? props.handler() : navigate('/projects', 'back')}>
        <IonIcon name="arrow-back" />
      </IonButton>
    </IonButtons>
  );
};
